import { render } from "./CharacteristicsSection.vue?vue&type=template&id=9761fac2&scoped=true"
import script from "./CharacteristicsSection.vue?vue&type=script&lang=js"
export * from "./CharacteristicsSection.vue?vue&type=script&lang=js"

import "./CharacteristicsSection.vue?vue&type=style&index=0&id=9761fac2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9761fac2"]])

export default __exports__